import api from './api'

/*
	The daily-reminder preference: load / save, plus the browser's IANA timezone
	so the server can fire the nudge at the player's local time. Shared by the
	Settings screen and the result-page opt-in prompt.
*/

// the browser's IANA timezone (e.g. 'Europe/London'), London on any failure
export function browserTz() {

	try {

		return Intl.DateTimeFormat().resolvedOptions().timeZone || 'Europe/London'

	} catch (e) {

		return 'Europe/London'

	}

}

// { enabled, time, tz, channel:{type,address} } for the signed-in player
export function load() {

	return api.request('reminder/load', {})

}

// persist the preference (tz defaults to the current browser zone)
export function save(enabled, time, tz) {

	return api.request('reminder/save', {
		enabled: !!enabled,
		time: time || '10:00',
		tz: tz || browserTz()
	})

}
